import React from 'react';
import { formatPriceForDisplay } from '../../domain/property/formatters';

/**
 * PriceTag — 분양가 표시 컴포넌트.
 *
 * 정책 (사용자 피드백 2026-05-21):
 *   - minPrice/maxPrice 가 있으면 실제 가격 노출 ("4억 1,790만 ~ 6억 1,620만원").
 *   - 둘 다 없으면 "가격 문의" 폴백.
 *
 * 가격은 청약홈 모집공고문 PDF에서 추출한 신뢰성 있는 정부 데이터 기반.
 */

export type PriceTagSize = 'sm' | 'md' | 'lg';

export interface PriceTagProps {
  /** 최저 분양가 (만원 단위). */
  minPrice?: number | null;
  /** 최고 분양가 (만원 단위). */
  maxPrice?: number | null;
  size?: PriceTagSize;
  /** 오렌지 강조 여부 (기본 true) */
  emphasize?: boolean;
  className?: string;
}

const sizeClasses: Record<PriceTagSize, string> = {
  sm: 'text-[12px]',
  md: 'text-[14px]',
  lg: 'text-[17px]',
};

export const PriceTag: React.FC<PriceTagProps> = ({
  minPrice,
  maxPrice,
  size = 'md',
  emphasize = true,
  className = '',
}) => {
  // 정책(2026-05-21): min/max 있으면 실가격, 없으면 "가격 문의" 폴백.
  const label = formatPriceForDisplay(minPrice, maxPrice);
  const colorClass = emphasize ? 'text-accent-dark' : 'text-ink';
  return (
    <span
      className={`font-extrabold tracking-tight ${sizeClasses[size]} ${colorClass} ${className}`}
      aria-label={label}  // 스크린리더가 실제 표시값(실가격/가격 문의)을 동일하게 읽도록
    >
      {label}
    </span>
  );
};

export default PriceTag;
